let vue3Router;
let vue2Router;
let baseInfo = {
    base: '/',
    env: 'dev',
    projectId: '',
    branch: '',
};
export function setVue3RouterBaseInfo(info) {
    baseInfo = info;
}
export function createRouterForGogo(router4Module, Vue3) {
    if (vue3Router)
        return vue3Router;
    const { createRouter, createMemoryHistory } = router4Module;
    const { h, watch, watchEffect, effectScope, ref } = Vue3;
    vue3Router = createRouter({
        history: createMemoryHistory(),
        routes: [
            // TODO 虽然 gogo 会动态注册，但是这可能也要一些404之类的默认页面
            { path: '/', component: { render: () => h('div', ['404']) } },
        ],
    });
    // 做绑定的事情
    vue2Router = window.xy_runtime_router; // ./src/router/runtimeModeRouter.js
    if (vue2Router) {
        if (lastVue3SyncPayload)
            notifyVue3RouterChanged(lastVue3SyncPayload);
        const scope = effectScope(true);
        scope.run(() => {
            vue3Router.beforeEach((to) => {
                if (isSyncing || !lastVue3SyncPayload)
                    return;
                if (vue2Router.currentRoute.fullPath !== to.fullPath) {
                    console.log('[vue3router][gogo] beforeEach', to);
                    vue2Router.push(to.fullPath);
                }
            });
            vue2Router.beforeEach((to, from, next) => {
                if (!(isSyncing || !lastVue3SyncPayload)) {
                    if (vue3Router.currentRoute.value.fullPath !== to.fullPath) {
                        console.log('[vue2router][gogo] beforeEach', to);
                        vue3Router.push(to.fullPath);
                    }
                }
                next();
            });
            watchEffect(() => {
                console.log('[vue-router][gogo] RR', [...vue3Router.getRoutes()]);
            });
        });
    }
    else {
        console.warn('[vue-router][gogo] cannot locate runtime vue-router instance');
    }
    return vue3Router;
}
let isSyncing = false;
let lastVue3SyncPayload = null;
export async function notifyVue3RouterChanged(payload) {
    if (!vue2Router || !vue3Router) {
        // not ready? next time sync
        lastVue3SyncPayload = payload;
        return;
    }
    // 好像没有删除路由的能力，先不管了
    // for (const r of lastVue3SyncPayload?.pages || []) {
    //   vue2Router.addRoute
    // }
    try {
        isSyncing = true;
        const GogoRuntimeRouterView = require('./GogoRuntimeRouterView.vue').default;
        for (const r of payload.pages) {
            const pageId = '[gogo-page]' + r.file;
            vue2Router.addRoute({
                path: r.routePath,
                name: pageId,
                component: GogoRuntimeRouterView,
                props: {
                    projectId: baseInfo.projectId,
                    pageId: pageId,
                },
                meta: {
                    // TODO: 各种 pageAttr 的东西？
                    "pageId": pageId,
                    "pageName": pageId,
                    "pageAttr": {
                        "navFixTop": "system",
                        "customNav": "system",
                        "customSidebar": "system",
                        "customHeader": "system",
                        "customFooter": "system",
                        "showWatermark": "system",
                        "keepAlive": false,
                        "isMobile": false
                    },
                    "isKeepAlive": false,
                    "layoutType": "header-sidebar-content",
                    "pageType": "content"
                }
            });
        }
        await vue3Router.replace(vue2Router.currentRoute.fullPath);
    }
    catch (e) {
        console.error('[vue-router][gogo] sync error', e);
    }
    isSyncing = false;
    lastVue3SyncPayload = JSON.parse(JSON.stringify(payload)); // lodash的原型可能有问题
}
